import { Injectable } from '@angular/core';
import { throwError as observablethrowError,Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
  })

export class DashboardService{
    

    public dashChange = new Subject<any>();
    changeObservable2$ = this.dashChange.asObservable();
    

    
};